export const chunkArray = <T>(array: T[], chunkSize: number): T[][] => {
  const chunkCount = Math.ceil(array.length / chunkSize);
  return Array.from({ length: chunkCount }, (_, i) =>
    array.slice(i * chunkSize, i * chunkSize + chunkSize),
  );
};
